<template>
  <div id="q-app">
    <!-- style="background-color:#edffea"-->
    <transition-group
      appear
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div key="div2" v-if="false" class="loaderOverlay">
        <div key="div2" class="lds-ripple">
          <div key="div3"></div>
          <div key="div4"></div>
        </div>
      </div>
    </transition-group>

    <q-layout>
      <app-bar
        v-if="$route.path != '/login' && !$route.path.includes('/mobile-view')"
      />
      <mobile-view-app-bar
        v-if="$route.path != '/login' && $route.path.includes('/mobile-view')"
      />
      <q-page-container>
        <router-view
          :class="{
            'q-pa-sm':
              $route.path != '/login' &&
              this.$q.screen.lt.sm &&
              !this.$route.path.includes('mobile-view'),
            'q-pa-md': $route.path != '/login' && this.$q.screen.gt.sm,
          }"
        />
      </q-page-container>
    </q-layout>
  </div>
</template>

<script>
import { auth } from "@/firebase.js";
import { mapGetters } from "vuex";
import AppBar from "@/components/AppBar";
import mobileViewAppBar from "@/components/pwa/mobileViewAppBar.vue";

export default {
  components: {
    AppBar,
    mobileViewAppBar,
  },
  computed: {
    ...mapGetters([
      "fullLoading",
      "currentUser",
      "currentUserData",
      "offlineMode",
    ]),
  },
  data: () => ({}),
  watch: {
    currentUser: function (oldData, newData) {
      this.checkLoggedIn();
    },
    $route: function (newRoute, oldRoute) {
      this.checkLoggedIn();
    },
  },
  mounted() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (
        window.location.host == "192.168.4.100" &&
        !this.$route.path.includes("mobile-view")
      ) {
        console.log(this.$route.path, "APP VUE REDIRECT 1");
        this.$router.push("/mobile-view/home");
      } else if (this.currentUser != null && this.currentUser != "loading") {
        if (this.$route.path === "/login") {
          // if (
          //   /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          //     navigator.userAgent
          //   )
          // ) {
          //   console.log("APP VUE REDIRECT 2");
          //   this.$router.push("/mobile-view/home");
          // } else {
          //   this.$router.push("/surveys");
          // }
          this.$router.push("/surveys");
        }
      } else if (this.currentUser != "loading") {
        if (
          this.$route.path != "/login" &&
          window.location.host != "192.168.4.100"
        ) {
          this.$router.push("/login");
        }
      }
    },
  },
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: $scrollbarTrack;
}
::-webkit-scrollbar-thumb {
  background: $scrollbarThumb;
}
::-webkit-scrollbar-thumb:hover {
  background: $scrollbarHover;
}
.loaderOverlay {
  z-index: 9999;
  background: #ffffff;
  width: 100vw;
  height: 100vh;
  position: fixed;
}
.lds-ripple {
  top: calc(50vh - 40px);
  left: calc(50vw - 40px);
  display: inline-block;
  position: fixed;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid $primary;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.swal2-container {
  z-index: 10600 !important;
}
</style>
